import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const CollapseMojoAudio = (props) => (
  <SvgIcon
    viewBox="0 0 18 18"
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  >
    <path
      fill="currentcolor"
      // eslint-disable-next-line max-len
      d="M13.9684 5.62613H16.8691C17.49 5.62613 17.9934 6.12949 17.9934 6.75043C17.9934 7.37137 17.49 7.87474 16.8691 7.87474H11.2476C10.6266 7.87474 10.1233 7.37137 10.1233 6.75043V1.12891C10.1233 0.507968 10.6266 0.00460026 11.2476 0.00460023C11.8685 0.00460023 12.3719 0.507968 12.3719 1.12891V4.01837L16.0708 0.330649C16.5117 -0.110216 17.2265 -0.110216 17.6673 0.330649C18.1082 0.771511 18.1082 1.4863 17.6673 1.92716L13.9684 5.62613ZM1.13082 10.1235H6.75235C7.37328 10.1235 7.87665 10.6269 7.87665 11.2478V16.8694C7.87665 17.4903 7.37328 17.9937 6.75235 17.9937C6.13141 17.9937 5.62804 17.4903 5.62804 16.8694V13.9687L1.92908 17.6676L1.92256 17.6741C1.4817 18.1114 0.769832 18.1085 0.332567 17.6676L0.326048 17.6611C-0.111216 17.2202 -0.108297 16.5084 0.332567 16.0711L4.02029 12.3721H1.13082C0.509887 12.3721 0.00651901 11.8688 0.00651898 11.2478C0.00651898 10.6269 0.509887 10.1235 1.13082 10.1235Z"
    />
  </SvgIcon>
);

export default CollapseMojoAudio;
